import React, { PropsWithChildren } from 'react'
import { getClassNames } from '../../../_utils/classnames'
import { Flex } from 'antd'

type BuilderMain = {
    className?: string
}

export const AppMessageBuilderMain: React.FC<PropsWithChildren<BuilderMain>> = (props) => {
    const { className, children } = props

    return (
        <Flex
            vertical
            justify="flex-start"
            flex={'1 1 auto'}
            gap={16}
            className={getClassNames('app-message-builder-main', className)}
        >
            {children}
        </Flex>
    )
}
